import { useCallback } from 'react';
import confetti from 'canvas-confetti';

/**
 * Custom hook for triggering confetti effects
 * Creates a fun explosion animation when adding items to cart
 */
export const useConfetti = () => {
  const triggerConfetti = useCallback(() => {
    // Create a colorful "POP" explosion with brand colors
    const colors = ['#FFC1CC', '#00FFFF', '#FFF44F', '#98FF98', '#FF4500', '#32CD32'];

    // Fire confetti from multiple angles for a bigger explosion
    const duration = 2000;
    const animationEnd = Date.now() + duration;

    const randomInRange = (min, max) => {
      return Math.random() * (max - min) + min;
    };

    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 50 * (timeLeft / duration);

      // Burst from the center with spread
      confetti({
        particleCount,
        startVelocity: 30,
        spread: 360,
        origin: {
          x: randomInRange(0.4, 0.6),
          y: randomInRange(0.4, 0.6)
        },
        colors,
        ticks: 200,
        gravity: 1,
        decay: 0.94,
        scalar: 1.2,
      });
    }, 250);
  }, []);

  const triggerSmallConfetti = useCallback(() => {
    // Smaller, quicker confetti burst
    const colors = ['#FFC1CC', '#00FFFF', '#FFF44F'];

    confetti({
      particleCount: 50,
      spread: 70,
      origin: { y: 0.6 },
      colors,
      ticks: 100,
    });
  }, []);

  const triggerHeartConfetti = useCallback(() => {
    // Heart-themed confetti for wishlist actions
    const scalar = 2;
    const heart = confetti.shapeFromPath({ path: 'M167 10c-33.73 0-61.07 27.34-61.07 61.07 0 19.32 15.82 40.7 56.07 72.61 40.25-31.91 56.07-53.29 56.07-72.61 0-33.73-27.34-61.07-61.07-61.07z' });

    confetti({
      shapes: [heart],
      particleCount: 25,
      spread: 60,
      origin: { y: 0.7 },
      colors: ['#FFC1CC', '#FF69B4', '#FF1493'],
      scalar,
      ticks: 150,
      gravity: 0.8,
      drift: 0,
      velocity: 35
    });
  }, []);

  return { triggerConfetti, triggerSmallConfetti, triggerHeartConfetti };
};

export default useConfetti;
